export const FILTER_KEY = {
  ROWS_COUNT: 'rowsCount'
};
